import React from 'react';
import { Box, Heading, useColorModeValue } from '@chakra-ui/react';

const PageLayout = ({ children, title }) => {
  const bgGradient = useColorModeValue('linear(to-br, blue.50, purple.100)', 'linear(to-br, gray.800, purple.900)');

  return (
    <Box
      minH="100vh"
      bgGradient={bgGradient}
      p={{ base: 4, md: 6 }}
      w="100%"
      position="relative"
      zIndex={1}
    >
      <Heading 
        size="lg" 
        mb={6} 
        bgGradient="linear(to-r, purple.500, blue.400)" 
        bgClip="text"
      >
        {title}
      </Heading>
      {children}
    </Box>
  );
};

export default PageLayout; 